import { render, staticRenderFns } from "./ToggleBox.vue?vue&type=template&id=d4c5624e&scoped=true&"
import script from "./ToggleBox.vue?vue&type=script&lang=js&"
export * from "./ToggleBox.vue?vue&type=script&lang=js&"
import style0 from "./ToggleBox.vue?vue&type=style&index=0&id=d4c5624e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4c5624e",
  null
  
)

export default component.exports